(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.ttmReady === 'true') return;
    var track = root.querySelector('[data-ttm-track]');
    if (!track) return;
    root.dataset.ttmReady = 'true';

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          track.classList.toggle('is-paused', !entry.isIntersecting);
        });
      }, { threshold: 0 });
      observer.observe(root);
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-ttm]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
